<template>
  <a-modal :title="title" :width="modalWidth" :visible="visible" :confirmLoading="confirmLoading" @ok="handleOk"
    @cancel="handleCancel" cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-table size="middle" rowKey="id"
        :row-selection="{ selectedRowKeys: this.selectedRowKeys, onChange: onSelectChange, type: rowSelectionType }"
        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
        :columns="columns" :loading="dataListLoading" :pagination="pagination" :scroll="{ y: 400 }"
        @change="pageChange"></a-table>
    </a-spin>
  </a-modal>
</template>

<script>
import mixinViewModule from '@/mixin/common'
const columns = [
  {
    title: '图层名字',
    dataIndex: 'layerName'
  },
  {
    title: '数据源',
    dataIndex: 'dataSource'
  },
  {
    title: '备注',
    dataIndex: 'remark'
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'UserInfo',
  props: {
    rowSelectionType: {
      type: String,
      default: 'checkbox'
    }
  },
  data () {
    return {
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['100']
      },
      selectedRowKeys: [],
      selectedRows: [],
      selectedRowsMap: new Map(),
      columns,
      queryUrl: '/manager/base-layer/page',
      title: '',
      modalWidth: 800,
      visible: false,
      confirmLoading: false,

      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },

      form: this.$form.createForm(this),
      url: 'manager/users'
    }
  },
  watch: {

  },
  methods: {
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      // 将当前页新选中的行数据加入 Map
      selectedRows.forEach(row => {
        this.selectedRowsMap.set(row.id, row)
      })
      // 从 Map 中移除取消选中的项
      for (const key of this.selectedRowsMap.keys()) {
        if (!selectedRowKeys.includes(key)) {
          this.selectedRowsMap.delete(key)
        }
      }
      // 更新 selectedRows
      this.selectedRows = Array.from(this.selectedRowsMap.values())
    },
    show (arr, existingRows = []) {
      this.visible = true
      this.selectedRowKeys = arr || []
      // 初始化 Map 存储已有的图层数据
      this.selectedRowsMap = new Map()
      if (existingRows && existingRows.length > 0) {
        existingRows.forEach(row => {
          this.selectedRowsMap.set(row.id, row)
        })
      }
      this.selectedRows = existingRows || []
      this.queryList()
    },
    handleCancel () {
      this.close()
    },
    close () {
      this.visible = false
      this.selectedRowKeys = []
      this.selectedRows = []
      this.selectedRowsMap = new Map()
    },
    handleOk () {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请至少选择一个图层')
        return
      }
      this.$emit('close', this.selectedRows)
      this.close()
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
</style>
